// extracted by mini-css-extract-plugin
export default {"Header":"base-module_Header_ku7VF","HeaderFocus":"base-module_HeaderFocus_qfN9Z","Content":"base-module_Content_jxO5M","opacity":"base-module_opacity_U8qdK"};